import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SoupKitchenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"soup_kitchen"}/>
}
